// @flow
import React, { Fragment } from 'react';
import ProductsTagsTemplate from 'components/tags/ProductsTagsTemplate';
import ProductsTagsTab from 'components/tags/ProductsTagsTab/ProductsTagsTab';
import { type ContextRouter } from 'react-router-dom';
import queryString from 'query-string';
import ProductsTagItemListContainer from 'containers/tags/ProductsTagItemListContainer';
import ProductsTagCurrentContainer from 'containers/tags/ProductsTagCurrentContainer';
import TagProductCards from 'containers/list/TagProductCards';
import { Helmet } from 'react-helmet';

type Props = {} & ContextRouter;

const ProductsTags = ({ location, match, history }: Props) => {
  const { sort } = queryString.parse(location.search);
  const { tag } = match.params;

  return (
    <ProductsTagsTemplate>
      {tag ? (
        <Helmet>
          <title>{`${tag} | 캐시바이`}</title>
          <meta
            name="description"
            content={`캐시바이에 등록된 #${tag} 태그를 가지고 있는 상품들을 모아보세요.`}
          />
        </Helmet>
      ) : (
        <Helmet>
          <title>상품 태그 | 캐시바이</title>
          <meta
            name="description"
            content="캐시바이에 등록된 다양한 상품들을 태그별로 분류해서 살펴보세요."
          />
        </Helmet>
      )}
      {tag ? (
        <Fragment>
          <ProductsTagCurrentContainer tag={tag} />
          <TagProductCards />
        </Fragment>
      ) : (
        <Fragment>
          <ProductsTagsTab sort={sort} />
          <ProductsTagItemListContainer sort={sort} />
        </Fragment>
      )}
    </ProductsTagsTemplate>
  );
};

export default ProductsTags;



// WEBPACK FOOTER //
// ./src/pages/ProductsTags.js